import React from 'react'
import { Modal } from '@vwfs-bronson/bronson-react'
import { ICustomerTrip } from '../../../models/customer-data.interface';
import { formatter, getFromToTimestampsPair, newestTimestamp } from '../../../utils/time-utils';
import CopyActionWrapper from '../copy-action-wrapper';
import { createDataDogQuery } from '../../../utils/DatadogUtils';
import { isBifrostAuthConfig } from '../../../utils/auth-utils';

interface MessageModalInterface {
  showModal: boolean;
  title?: string;
  trip: ICustomerTrip;
  handleOnModalClose: () => void;
}

export default function TripDetailsModal({ trip, showModal, handleOnModalClose, title }: MessageModalInterface) {
  if (!trip) {
    return null;
  }

  const completedCharge = trip.billings.find(b => b.state === 'COMPLETED' && b.type === 'CHARGE');
  const endTimestamp = trip?.state === 'COMPLETED' && trip.preauth?.endTimestamp ? trip?.preauth?.endTimestamp : null;
  const capturedAt = newestTimestamp([completedCharge?.timestamp, endTimestamp])

  const lastUpdatedAt = newestTimestamp([trip?.preauth?.lastUpdatedTimestamp, capturedAt]);

  const { from: fromTimestamp, to: toTimestamp } = getFromToTimestampsPair()
  const serviceProviderTripId = trip.externalTripIdentifiers?.find(entry => entry.type.endsWith('_TRIP_ID'))?.id;
  const dataDogUri = createDataDogQuery(trip.customerId, trip.id, serviceProviderTripId, fromTimestamp, toTimestamp);

  const renderMessage = () => {
    return (
      <div
        data-testid='DetailsModal-content'
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem'
        }}>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Last Update</h5>
            <span data-testid='test-modal-message'>
              {lastUpdatedAt ? formatter.format(new Date(lastUpdatedAt)) : '-'}
            </span>
          </div>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Payment Capture</h5>
            <span data-testid='test-modal-message'>
              {capturedAt ? formatter.format(capturedAt) : '-'}
            </span>
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>Payment Transaction ID</h5>
            <span data-testid='test-modal-message'>
              {
                trip.paymentId ? <CopyActionWrapper>{trip.paymentId}</CopyActionWrapper> : '-'
              }
            </span>
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '2rem'
        }}>
          <div>
            <h5 style={{
              color: 'black',
              fontSize: '18px',
              lineHeight: '1.3',
              margin: '0',
            }}>VWFS Trip ID</h5>
            <span data-testid='test-modal-message'>
              <CopyActionWrapper>{trip.id}</CopyActionWrapper>
            </span>
          </div>
        </div>

        {
          isBifrostAuthConfig() && trip.id &&
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '2rem'
          }}>
            <div>
              <a target="blank" href={dataDogUri}><h5 style={{
                color: 'black',
                fontSize: '18px',
                lineHeight: '1.3',
                margin: '0',
              }}>See Datadog Logs</h5></a>
            </div>
          </div>
        }

      </div>
    )
  }

  return <Modal
    shown={showModal}
    onClose={handleOnModalClose}
    onConfirm={handleOnModalClose}
    buttonConfirmLabel='Ok'
    buttonConfirmText='Ok'
    title={title ? title : `Action`}
    large={false}
    stretch={true}
    status='info'
    testId='trip-details-modal'>
    {renderMessage()}
  </Modal>
}
